import { useEffect } from "react";
import { hideLoading } from "../../utils/utilityEtc";

const HideSplashScreen = ( props ) => {

  useEffect( () => {
    hideLoading();
  }, [] );

  return props.children || null;

};

export default HideSplashScreen;
